import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ClickableDiv from 'components/Common/ClickableDiv';
import Styles from './index.module.css';
// icons

function CardBar({
  onClick,
  children,
  bgStyle,
}) {
  return (
    <ClickableDiv
      className={classNames(Styles.container, bgStyle)}
      onClick={onClick}
    >
      {children}
    </ClickableDiv>
  );
}

CardBar.propTypes = {
  onClick: PropTypes.func,
  children: PropTypes.node,
  bgStyle: PropTypes.string,
};

CardBar.defaultProps = {
  onClick: () => {},
  children: null,
  bgStyle: '',
};

export default CardBar;
